import { Icon } from "@iconify/react";
import React from "react";
import { useNavigate } from "react-router-dom";

const UnitCountFour = ({
  todayEvents,
  newEvents,
  acceptedEvents,
  todayUsers,
  totalUsers,
  todayReaders,
  totalReaders,
  totalChurches,
  todayAppOpens,
}) => {
  const navigate = useNavigate(); // initialize navigate
  const fields = [
    {
      title: "Today Events",
      value: todayEvents,
      icon: "mdi:calendar-today",        // matches today's events
      bgColor: "bg-primary-600",
      info: "Total events created in system",
      route: "/events",
    },
    {
      title: "New Events",
      value: newEvents,
      icon: "mdi:calendar-plus",         // adding new events
      bgColor: "bg-brown",
      info: "Events created recently",
      route: "/events",
    },
    {
      title: "Accepted Events",
      value: acceptedEvents,
      icon: "mdi:calendar-check",        // accepted/completed events
      bgColor: "bg-cyan",
      info: "Events already expired",
      route: "/events",
      tab: "accepted",
    },
    {
      title: "Total Users",
      value: totalUsers,
      icon: "mdi:account-group",         // total users
      bgColor: "bg-pri-noreply",
      info: "Total registered users",
      route: "/mobile-users",
    },
    {
      title: "New Users",
      value: todayUsers,
      icon: "mdi:account-plus",          // new users today
      bgColor: "bg-success-main",
      info: "Users registered today",
      route: "/mobile-users",
    },
    {
      title: "Total Readers",
      value: totalReaders,
      icon: "mdi:book-multiple",
      bgColor: "bg-red",
      info: "Total registered readers",
      route: "/readingplan",
    },
    {
      title: "Total Churches",
      value: totalChurches,
      icon: "mdi:church",
      bgColor: "bg-red",
      info: "Total registered churches",
      route: "/churches",
    },
    {
      title: "Today App Opens",
      value: todayAppOpens,
      icon: "mdi:cellphone-check",
      bgColor: "bg-purple",
      info: "Users who opened the app today",
      route: "/mobile-users",
    },
  ];


  return (
    <div className="col-12">
      <div className="row gy-4">
        {fields.map((field, index) => (
          <div key={index} className="col-xxl-3 col-sm-6">
            <div
              onClick={() => {
                if (field.route) {
                  if (field.tab) {
                    navigate(field.route, { state: { tab: field.tab } });
                  } else {
                    navigate(field.route);
                  }
                }
              }}
              style={{ cursor: field.route ? "pointer" : "default" }}
              className={`card px-24 py-16 shadow-none radius-8 border h-100 bg-gradient-end-${index + 1}`}
            >
              <div className="card-body p-0">
                <div className="d-flex align-items-center gap-3">
                  <div className="w-64-px h-64-px radius-16 bg-base-50 d-flex justify-content-center align-items-center">
                    <span
                      className={`w-40-px h-40-px ${field.bgColor} text-white d-flex justify-content-center align-items-center radius-8`}
                    >
                      <Icon icon={field.icon} className="icon" />
                    </span>
                  </div>

                  <div>
                    <span className="text-secondary-light text-md">
                      {field.title}
                    </span>

                    <h6 className="fw-semibold my-1">{field.value ?? 0}</h6>


                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UnitCountFour;